import { Box, Button, Typography } from '@mui/material';

import {
  QUEUE_VIEW_KEYS,
  type QueueViewKey,
  WORK_VIEW_LABELS,
} from '../../billing/types/encounterWork';
import type { MorningWorklistClaimCounts } from '../types';

export function ClaimQueueCounts({
  counts,
  onSelect,
}: {
  counts: MorningWorklistClaimCounts;
  onSelect?: (view: QueueViewKey) => void;
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 1,
      }}
    >
      {QUEUE_VIEW_KEYS.map(view => {
        const content = (
          <>
            <Typography variant="caption" color="text.secondary">
              {WORK_VIEW_LABELS[view]}
            </Typography>
            <Typography sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
              {counts[view] ?? 0}
            </Typography>
          </>
        );
        return onSelect ? (
          <Button
            key={view}
            color="inherit"
            onClick={() => onSelect(view)}
            sx={{
              alignItems: 'flex-start',
              bgcolor: 'action.hover',
              flexDirection: 'column',
              p: 1,
              textAlign: 'left',
              textTransform: 'none',
            }}
          >
            {content}
          </Button>
        ) : (
          <Box key={view} sx={{ bgcolor: 'action.hover', borderRadius: 1, p: 1 }}>
            {content}
          </Box>
        );
      })}
    </Box>
  );
}
